<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/IDTs">
              Financial Services
            </b-breadcrumb-item>
            <b-breadcrumb-item active>Computer Leases</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Leases</div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row justify-content-center">
                            <div class="col form-group">
                                <label for="assetNumber">Asset Number</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Asset Number"
                                        v-model="filterOptions.assetNumber"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="serialNumber">Serial Number</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Serial Number"
                                        v-model="filterOptions.serialNumber"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="manufacturer">Manufacturer</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Manufacturer"
                                        v-model="filterOptions.manufacturer"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="modelNumber">Model Number</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Model Number"
                                        v-model="filterOptions.modelNumber"
                                />
                            </div>
                        </div>
                        <div class="form-row justify-content-center">
                            <div class="col-auto form-group">
                                <label for="vendor">Vendor</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Vendor"
                                        v-model="filterOptions.vendor"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label for="lesseeName">Lessee Name</label>
                                <input  @keyup="searchPerformed=false"
                                        class="form-control"
                                        placeholder="Lesse Name"
                                        v-model="filterOptions.lesseeName"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <AppCheckBox v-model="filterOptions.onlyShowActiveLeases">
                                    Only Show Active Leases
                                </AppCheckBox>
                            </div>
                            <div class="col-md-4 col-sm-6 form-group align-self-center">
                                <AppCheckBox v-model="filterOptions.onlyShowDataIssues">
                                    Only Show Data with Issues
                                </AppCheckBox>
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <!--<template v-if="filterOptions.assetNumber !== null && filterOptions.assetNumber.trim() !== '' && computerLeases.length === 0 && searchPerformed">
                            <RouterLink :to="{name:'AddComputerAsset',params:{assetNumber:filterOptions.assetNumber}}" class="btn btn-success text-left"
                                        title="Add New Computer Lease">
                                <i class="fa fa-plus"></i>Add Computer Asset
                            </RouterLink>
                        </template>-->
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>
                <div class="d-print-none dropdown mb-3 text-right">
                    <button :disabled="isPerformingAction" aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown" style="width: 100px" type="button">
                        <span>Actions</span>
                    </button>
                    <div class="dropdown-menu">
                        <!--<RouterLink :to="{name: 'AddComputerLease'}" class="btn btn-outline-light dropdown-item text-left"
                                    title="Add New Computer Lease">
                            <i class="fa fa-plus"></i>Add
                        </RouterLink>-->
                        <a @click.prevent="downloadCsvExport()" class="btn btn-outline-light dropdown-item text-left"
                            href="javascript:void(0)" title="Export active leases list to a CSV">
                            <i class="fa fa-file-excel"></i>Download Active Leases .csv
                        </a>
                    </div>
                </div>
                <BTable :busy="isLoading"
                        :fields="tableFields"
                        :items="computerLeases"
                        :responsive="true"
                        primary-key="id"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                      <div class="row">
                        <div class="col-auto">
                          <a @click="toggleDetails(row)" class="ml-3">
                            <i v-if="!row.item._showDetails" class="fa fa-caret-down fa-lg" />
                            <i v-if="row.item._showDetails" class="fa fa-caret-up fa-lg" />
                          </a>
                        </div>
                        <div class="btn-group col-auto">
                            <router-link
                                    :to="{ name:'EditComputerLease', params:{ id: row.item.id } }"
                                    class="btn btn-sm btn-warning d-print-none"
                                    data-toggle="tooltip"
                                    title="Edit computer lease">
                                <i class="fa fa-pencil-alt"></i>Edit
                            </router-link>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(assetNumber)="row">
                        <i v-if="row.item.accountId == null || row.item.leseePersonId == null || row.item.accountNumber == null || row.item.lesseePersonName == null || (row.item.leasePurchaseAccountIsActive != null && !row.item.leasePurchaseAccountIsActive) || (row.item.lesseePersonIsActive != null && !row.item.lesseePersonIsActive) || (row.item.leasePurchaseAccountIsFrozen != null && row.item.leasePurchaseAccountIsFrozen) || (row.item.isSpecialProjectRequest && row.item.specialProjectRequests.filter((f) => { return (f.accountIsActive != null && f.accountIsActive) || (f.accountIsFrozen != null && !f.accountIsFrozen) })).length > 0" class="fa fa-exclamation-circle" style="color: red !important;display:inline;padding-right:5px;"></i>
                        <span>{{ row.item.assetNumber }}</span>
                    </template>

                    <template v-slot:cell(isSpecialProjectRequest)="row">
                        <span>{{ row.item.isSpecialProjectRequest ? 'Yes' : 'No' }}</span>
                    </template>

                    <template v-slot:row-details="row">
                        <b-container>
                            <div>
                                <fieldset v-if="row.item.accountId == null || row.item.leseePersonId == null || row.item.leasePurchaseAccountNumber == null || row.item.lesseePersonName == null || (row.item.leasePurchaseAccountIsActive != null && !row.item.leasePurchaseAccountIsActive) || (row.item.lesseePersonIsActive != null && !row.item.lesseePersonIsActive) || (row.item.leasePurchaseAccountIsFrozen != null && row.item.leasePurchaseAccountIsFrozen) || (row.item.isSpecialProjectRequest && row.item.specialProjectRequests.filter((f) => { return (f.accountIsActive != null && !f.accountIsActive) || (f.accountIsFrozen != null && !f.accountIsFrozen) }).length > 0)" class="border p-3 mr-2">
                                    <legend class="w-auto h5">Sync Data Issues</legend>
                                    <b-row>
                                        <b-col>
                                            <div class="font-weight-bold">FAMIS Missing Account</div>
                                            <div class="pl-4">{{ row.item.leasePurchaseAccountNumber == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">FAMIS Missing Lessee</div>
                                            <div class="pl-4">{{ row.item.lesseePersonName == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">BIMS Missing Account</div>
                                            <div class="pl-4">{{ row.item.leasePurchaseAccountId == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">BIMS Missing Lessee</div>
                                            <div class="pl-4">{{ row.item.lesseePersonId == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Account Inactive</div>
                                            <div class="pl-4">{{ row.item.leasePurchaseAccountId == null ? "Unkown" :  row.item.leasePurchaseAccountIsActive ? "No" : "Yes" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Account Frozen</div>
                                            <div class="pl-4">{{ row.item.leasePurchaseAccountId == null ? "Unkown" :  row.item.leasePurchaseAccountIsFrozen ? "No" : "Yes" }}</div>
                                        </b-col>
                                        <b-col v-if="row.item.isSpecialProjectRequest">
                                            <div class="font-weight-bold">Special Project Accounts Inactive</div>
                                            <div class="pl-4">{{ row.item.specialProjectRequests.filter((f) => { return f.accountIsActive != null && !f.accountIsActive }).length > 0 ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col v-if="row.item.isSpecialProjectRequest">
                                            <div class="font-weight-bold">Special Project Accounts Frozen</div>
                                            <div class="pl-4">{{ row.item.specialProjectRequests.filter((f) => { return f.accountIsFrozen != null && !f.accountIsFrozen }).length > 0 ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Lessee Inactive</div>
                                            <div class="pl-4">{{ row.item.lesseePersonId == null ? "Unkown" :  row.item.lesseeIsActive ? "No" : "Yes" }}</div>
                                        </b-col>
                                    </b-row>
                                </fieldset>
                                <br>
                            </div>
                            <div v-if="row.item.isSpecialProjectRequest" class="card">
                                <div class="card-header">
                                    <ul class="card-header-tabs nav nav-tabs">
                                        <li class="nav-item">
                                            <a data-toggle="tab"
                                            role="tab"
                                            class="active nav-link"
                                            :aria-controls="'details-' + row.item.id"
                                            type="button"
                                            :data-target="'#details-' + row.item.id">Details</a>
                                        </li>
                                        <li class="nav-item">
                                            <a data-toggle="tab"
                                            role="tab"
                                            class="nav-link"
                                            :aria-controls="'billing-' + row.item.id"
                                            type="button"
                                            :data-target="'#billing-' + row.item.id">Billing</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab-content m-3">
                                    <div class="tab-pane active" :id="'details-' + row.item.id" role="tabpanel" aria-labelledby="details-tab">
                                        <br />
                                        <b-container>
                                            <div v-for="detailSection in detailFields" :key="detailSection">
                                                <template v-if="detailSection.sectionLabel !== null">
                                                    <fieldset class="border p-3 mr-2">
                                                        <legend class="w-auto h5">{{ detailSection.sectionLabel }}</legend>
                                                        <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                                            <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                                <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                                <div v-if="detailCell.type === 'currency'" class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] | currency }}</div>
                                                                <div v-else class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                                            </b-col>
                                                        </b-row>
                                                    </fieldset>
                                                </template>
                                                <template v-else>
                                                    <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                                        <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                            <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                            <div v-if="detailCell.type === 'currency'" class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] | currency }}</div>
                                                            <div v-else class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                                        </b-col>
                                                    </b-row>
                                                </template>
                                                <br>
                                            </div>
                                        </b-container>
                                    </div>
                                    <div class="tab-pane" :id="'billing-' + row.item.id" role="tabpanel" aria-labelledby="billing-tab">
                                        <br />
                                        <BTable :fields="innerTableFields"
                                                :items="row.item.specialProjectRequests"
                                                :responsive="true"
                                                primary-key="accountId"
                                                show-empty
                                                small
                                                table-class="table-align-middle">

                                            <template v-slot:cell(percentageSplit)="row">
                                                {{ row.item.percentageSplit }}%
                                            </template>
                                        </BTable>
                                    </div>
                                </div>
                            </div>
                            <b-container v-else>
                                <div v-for="detailSection in detailFields" :key="detailSection">
                                    <template v-if="detailSection.sectionLabel !== null">
                                        <fieldset class="border p-3 mr-2">
                                            <legend class="w-auto h5">{{ detailSection.sectionLabel }}</legend>
                                            <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                                <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                    <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                <div v-if="detailCell.type === 'currency'" class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] | currency }}</div>
                                                <div v-else class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                                </b-col>
                                            </b-row>
                                        </fieldset>
                                    </template>
                                    <template v-else>
                                        <b-row v-for="detailRow in detailSection.sectionDetails" :key="detailRow">
                                            <b-col v-for="detailCell in detailRow" :key="detailCell.key">
                                                <div class="font-weight-bold">{{ detailCell.label }}</div>
                                                <div v-if="detailCell.type === 'currency'" class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] | currency }}</div>
                                                <div v-else class="pl-4">{{ row.item[detailCell.key] === null ? "-" : row.item[detailCell.key] }}</div>
                                            </b-col>
                                        </b-row>
                                    </template>
                                    <br>
                                </div>
                            </b-container>
                        </b-container>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalComputerLeases"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>
                </BTable>
            </div>
        </div>
    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import ComputersService from "@/services/ComputersService";
    import {currency} from "../../filters/Currency";

    export default {
        components: {
            AppTablePagination,
            AppFormCardCollapsable,
            AppCheckBox
        },
        filters: {
            currency
        },
        data() {
            return {
                isPerformingAction: false,
                computerLeases: [],
                totalComputerLeases: 0,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    returnAll: false,
                    assetNumber: null,
                    serialNumber: null,
                    manufacturer: null,
                    modelNumber: null,
                    description: null,
                    vendor: null,
                    lesseeName: null,
                    onlyShowActiveLeases: true,
                    onlyShowDataIssues: false
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:150px'
                    }, 
                    {
                        key: 'assetNumber',
                        label: 'Asset Number'
                    },
                    {
                        key: 'serialNumber',
                        label: 'Serial Number'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                    },
                    {
                        key: 'leasePurchaseAccountNumber',
                        label: 'Billing Account',
                    },
                    {
                        key: 'isSpecialProjectRequest',
                        label: 'Billed to Different Account(s)',
                    }
                ],
                innerTableFields: [
                    {
                        key: 'accountNumber',
                        label: 'SL-SA'
                    },
                    {
                        key: 'fiscalPeriod',
                        label: 'Fiscal Period'
                    },
                    {
                        key: 'percentageSplit',
                        label: 'Percentage Split'
                    }
                ],
                detailFields: [
                    {
                        sectionLabel: null,
                        sectionDetails: [
                            [
                                {
                                    key: "custodianPersonName",
                                    label: "Custodian",
                                    type: null
                                }
                            ]
                        ]
                    },
                    {
                        sectionLabel: "Asset",
                        sectionDetails: [
                            [
                                {
                                    key: "manufacturer",
                                    label: "Manufacturer",
                                    type: null
                                },
                                {
                                    key: "modelNumber",
                                    label: "Model Number",
                                    type: null
                                }
                            ],
                            [
                                {
                                    key: "vendor",
                                    label: "Vendor",
                                    type: null
                                },
                                {
                                    key: "warrantyPeriod",
                                    label: "Warranty Period",
                                    type: null
                                }
                            ]
                        ]
                    },
                    {
                        sectionLabel: "Lease",
                        sectionDetails: [
                            [
                                {
                                    key: "lesseePersonName",
                                    label: "Lessee",
                                    type: null
                                },
                                {
                                    key: "lesseeOrganization",
                                    label: "Lessee Current Program Code",
                                    type: null
                                }
                            ],
                            [
                                {
                                    key: "leaseRate",
                                    label: "Lease Rate",
                                    type: "currency"
                                },
                                {
                                    key: "leasePeriod",
                                    label: "Lease Period",
                                    type: null
                                }
                            ]
                        ]
                    }
                ],
                searchPerformed: false
            }
        },
        methods: {
            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
                this.searchPerformed = true
            },

            loadData() {
                const vm = this;
                vm.isLoading = true;

                ComputersService.getComputerLeases(vm.filterOptions)
                  .then(response => {
                    vm.computerLeases = response.data.map(obj => ({ ...obj, 
                                                                    leasePeriod: obj.leaseStartDate === null || obj.leaseEndDate === null 
                                                                                    ? null
                                                                                    : (new Date(obj.leaseStartDate).toLocaleDateString()) + ' - ' + (new Date(obj.leaseEndDate).toLocaleDateString()),
                                                                    warrantyPeriod: obj.warrantyStartDate === null || obj.warrantyEndDate === null
                                                                                        ? null
                                                                                        : (new Date(obj.warrantyStartDate).toLocaleDateString()) + ' - ' + (new Date(obj.warrantyEndDate).toLocaleDateString()),
                                                                    createdDate: new Date(obj.createdDate).toLocaleDateString(),
                                                                    lastModifiedDate: new Date(obj.lastModifiedDate).toLocaleDateString(),
                                                                    specialProjectRequests: obj.specialProjectRequests.map(s => ({ ...s, fiscalPeriod: s.fiscalPeriodStartDate === null || s.fiscalPeriodEndDate === null 
                                                                                                ? null
                                                                                                : (new Date(s.fiscalPeriodStartDate).toLocaleDateString()) + ' - ' + (new Date(s.fiscalPeriodEndDate).toLocaleDateString()) })),
                                                                    _showDetails: false }));
                    vm.totalComputerLeases = response.totalCount;
                  })
                  .catch(() => {
                    vm.redirectToError()
                  })
                  .finally(() => {
                    vm.isLoading = false;
                  })
            },

            toggleDetails (row) {
              if (!row.item._showDetails) {
                row.item._showDetails = true;
              } else {
                row.item._showDetails = false;
              }
            },

            /**
             * @description Downloads the computer leases CSV export to the user's browser
             */
            downloadCsvExport() {
                this.isPerformingAction = true;
                const vm = this;

                ComputersService.getComputerLeasesExcelExport()
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    })
                    .finally(() => {
                        this.isPerformingAction = false
                    });
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
